import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { post } from "../../lib/request"

export const sendNotifyEmail = createAsyncThunk("notifyEmail/send", async (topicIds, { rejectWithValue }) => {
  try {
    const topicIdsParam = topicIds.map((id) => `topicIds=${id}`).join("&")
    const endpoint = `topics/email-for-approval?${topicIdsParam}`
    const response = await post(endpoint, {})
    return response
  } catch (error) {
    return rejectWithValue(error.message || "Failed to send email notification")
  }
})
// </CHANGE>

const notifyEmailSlice = createSlice({
  name: "notifyEmail",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    clearNotifyEmailError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendNotifyEmail.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(sendNotifyEmail.fulfilled, (state) => {
        state.status = "succeeded"
        state.error = null
      })
      .addCase(sendNotifyEmail.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { clearNotifyEmailError } = notifyEmailSlice.actions
export default notifyEmailSlice.reducer
